module.exports = __webpack_public_path__ + "img/banner-light.83af4f01.png";